import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { AlertTriangle, CalendarClock, Loader2 } from "lucide-react";

function ReminderRow({ r, navigate }) {
  return (
    <div onClick={() => navigate("/vozidla")} data-testid={`reminder-row-${r.vehicle_id}`}
      className={`flex cursor-pointer items-center justify-between gap-3 rounded-lg border px-4 py-3 transition-colors hover:border-primary/50 ${r.overdue ? "border-red-500/40 bg-red-500/10" : "border-amber-500/30 bg-amber-500/10"}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-1.5 text-sm font-medium">
          {r.overdue && <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-red-400" />}
          <span className="plate text-xs">{r.spz}</span>
          <span className="text-xs text-muted-foreground">{r.type}</span>
        </div>
        <div className="mt-0.5 text-xs text-muted-foreground">{r.label}</div>
        <div className="mt-0.5 text-xs text-muted-foreground">
          {r.date ? new Date(r.date).toLocaleDateString("sk-SK") : `${Number(r.current_km).toLocaleString("sk-SK")} / ${Number(r.km).toLocaleString("sk-SK")} km`}
        </div>
      </div>
      <span className={`shrink-0 text-sm font-semibold ${r.overdue ? "text-red-400" : "text-amber-400"}`}>
        {r.date ? (r.overdue ? `${Math.abs(r.days)} dní po` : `o ${r.days} dní`) : (r.overdue ? "prekročené" : "blíži sa")}
      </span>
    </div>
  );
}

export default function Reminders() {
  const navigate = useNavigate();
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/reminders").then((r) => setReminders(r.data.reminders || [])).finally(() => setLoading(false));
  }, []);

  const overdue = reminders.filter((r) => r.overdue);
  const upcoming = reminders.filter((r) => !r.overdue);

  return (
    <div>
      <PageHeader title="Pripomienky" subtitle="STK, EK, servis a výmeny oleja – 30 dní pred termínom a do 30 dní po termíne" />
      {loading ? (
        <div className="grid place-items-center py-24"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
      ) : (
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="card-surface p-5" data-testid="reminders-overdue">
            <h3 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold uppercase"><AlertTriangle className="h-5 w-5 text-red-400" /> Po termíne ({overdue.length})</h3>
            {overdue.length ? <div className="space-y-2">{overdue.map((r, i) => <ReminderRow key={i} r={r} navigate={navigate} />)}</div>
              : <p className="text-sm text-muted-foreground">Žiadne termíny po splatnosti.</p>}
          </div>
          <div className="card-surface p-5" data-testid="reminders-upcoming">
            <h3 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold uppercase"><CalendarClock className="h-5 w-5 text-amber-400" /> Blížia sa ({upcoming.length})</h3>
            {upcoming.length ? <div className="space-y-2">{upcoming.map((r, i) => <ReminderRow key={i} r={r} navigate={navigate} />)}</div>
              : <p className="text-sm text-muted-foreground">Žiadne blížiace sa termíny.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
